import type { SidePanel } from '../types';

export const PayPenalty: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./PayPenaltyPanel.vue')),
};
